import type { UscNavStepEnum } from "../../utils/constants";

export const USC_NAV_SET_STEP = "nav/setStep";

export type UscSetStepType = {
    type: typeof USC_NAV_SET_STEP;
    step: UscNavStepEnum;
};

export const setStep = (step: UscNavStepEnum): UscSetStepType => ({ type: USC_NAV_SET_STEP, step });

export type UscNavActionsType = UscSetStepType;
